import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EAECF0",
      d: "M0 4.005a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v28H0v-28Z"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      fill: "#2970FF",
      d: "M0 31.995h48v8a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4v-8Z"
    }, null, -1 /* HOISTED */),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M8.667 37.995H3.334m0 0 2 2m-2-2 2-2M39.666 37.995h4.667m0 0L42 35.66m2.333 2.334L42 40.328"
    }, null, -1 /* HOISTED */)
  ])))
}
export default { render: render }